/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { EntityVersion, ID } from '@gh/common-shared-data';
import {
  AutocompleteLoadMoreEvent,
  DialogInput,
  NotificationService,
  WaitingService,
} from '@gh/core-ui';
import { LeadDetailsBusinessService } from '../../../resources/lead-details-business.service';
import { LeadDetailsInit, UserDetailsShort } from '../../../resources/lead.model';

@Component({
  standalone: false,
  selector: 'gh-component-reassign-dialog',
  templateUrl: 'lead-details-reassign-dialog.component.html',
  styleUrls: ['lead-details-reassign-dialog.component.scss'],
})
export class LeadDetailsReassignDialogComponent implements OnInit, DialogInput<ComponentLeadDetailsReassignConfig> {
  input: ComponentLeadDetailsReassignConfig;

  leadId: ID;
  salesPersonId: ID;

  constructor(private dialogRef: MatDialogRef<any>,
              private businessService: LeadDetailsBusinessService,
              private waitingService: WaitingService,
              private notifications: NotificationService) {
  }

  ngOnInit(): void {

    this.leadId = this.input && this.input.leadId;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  loadSalesPersons(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.findSalesPersonsByName(event.query, this.input.excludedSalesPersonId));
  }

  onSalesPersonSelected(salesPerson: UserDetailsShort): void {
    this.salesPersonId = salesPerson && salesPerson.userId;
  }

  onReassign(): void {
    this.businessService.reassign(this.leadId, this.input.version, this.salesPersonId).pipe(
      this.waitingService.operator<LeadDetailsInit>())
      .subscribe(
        (init: LeadDetailsInit) => this.dialogRef.close(init),
        this.notifications.processAll,
      );
  }
}

export const componentReassignLeadDialogRoute = createDialogRoute({
  component: LeadDetailsReassignDialogComponent,
  config: { autoFocus: false },
});

export interface ComponentLeadDetailsReassignConfig {
  leadId: ID;
  excludedSalesPersonId: ID;
  version: EntityVersion;
}
